module.exports = __webpack_public_path__ + "static/img/3.5a17ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/entrance/3.png
// module id = yxVR
// module chunks = 1